module.exports = __webpack_public_path__ + "img/button.42e491c6.png";